import { Component, OnInit } from '@angular/core';
// import { JsonResponseModel } from '../shared/interfaces';
import { reportingFilter } from '../../models/filter.model';
import { scheduling } from '../../models/scheduling.model';
import { CommonService } from '../../services/common.service';
import { EventListenerService } from '../../services/close-listenenr.service';


@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

  title: string = 'Summary';
  reportingType: string = '';
  reportType: string;
  reportName: string;
  selectedCols: any;
  currentFilters: Array<reportingFilter> = [];
  schedule: scheduling;

  customReport: any = null;

  report: CustomReport = new CustomReport;

   constructor(
    private commonService: CommonService
    , protected closeService: EventListenerService
  ) { 
    
  }

  ngOnInit() {
  }

  

  submit = () => {
    this.report.ReportName = this.reportName;
    // this.report.LoginID = this.commonService.CurrentUser;
    this.report.Columns = this.selectedCols;
    this.report.FiltersJSON = JSON.stringify(this.currentFilters);
    this.report.SchedulingJSON = JSON.stringify(this.schedule);

    // switch(this.reportingType)
    // {
    //     case 'customQuote':
    //         this.report.ReportType = 'QH';
    //         break;       
    //     case 'quoteDetail':
    //         this.report.ReportType = 'QD';
    //         break;
    // }

    // if (this.schedule.frequency === 'DOWNLOAD NOW')
    // {
    //   var columnsString: string = '';

    //   for (var i = 0; i < this.report.Columns.length - 1; i++)
    //   {
    //       columnsString += this.report.Columns[i] + ',';
    //   }
    //   columnsString += this.report.Columns[this.report.Columns.length - 1];

    //   this.downloadReport(columnsString, this.report.FiltersJSON, this.report.ReportType);
    // }

    // if(this.action === "NEW")
    // {
    //   this.commonService.postWithJson(
    //     'api/Quotes/AddCustomReport'
    //     , this.report
    //     , res => {
    //       const response: JsonResponseModel = res.json();
    //       if (response.result === "Success"){
    //         this.commonService.showSuccess('#submitButton', "SUCCESSFULLY SAVED REPORT!", "left");
    //       }
    //       else
    //       {
    //         console.log(response.errors);
    //       }
    //       this.closeService.closeEvent('reportSubmitted');
    //     });
    // }
    // else
    // {
    //   this.report.ReportID =  this.customReport.reportId;

    //   this.commonService.postWithJson(
    //     'api/Quotes/UpdateCustomReport'
    //     , this.report
    //     , res => {
    //       const response: JsonResponseModel = res.json();
    //       if (response.result === "Success"){
    //         this.commonService.showSuccess('#submitButton', "SUCCESSFULLY UPDATED REPORT!", "left");
    //       }
    //       else
    //       {
    //         this.commonService.showError('#submitButton', "ERROR OCCURRED, PLEASE CONTACT IT SUPPORT!", "left");
    //         console.log(response.errors);
    //       }
    //       this.closeService.closeEvent('reportSubmitted');
    //     });
    // }
  
  }

  downloadReport = (columns: string, filters: string, reportType: string) => {
    // this.commonService.downloadCustomReport(columns, filters, reportType);
  }

  close = () => {
    this.closeService.closeEvent('summary');
  }

  get schedulingFreq ()
  {
    //  return this.commonService.schedulingFreq;
    return [
      'DOWNLOAD NOW'
      , 'ONCE'
      , 'WEEKLY'
      , 'MONTHLY'
    ];
  }

  get daysOfTheWeek ()
  {
    //  return this.commonService.daysOfTheWeek;
    return [
      'MONDAY'
      , 'TUESDAY'
      , 'WEDNESDAY'
      , 'THURSDAY'
      , 'FRIDAY'
      , 'SATURDAY'
      , 'SUNDAY'
    ];
  }

  get daysOfTheMonth ()
  {
    //  return this.commonService.daysOfTheMonth;
    return [
      'LAST'
      ,'01' ,'02' ,'03' ,'04' ,'05' ,'06' ,'07' ,'08' ,'09' ,'10'
      ,'11' ,'12' ,'13' ,'14' ,'15' ,'16' ,'17' ,'18' ,'19' ,'20'
      ,'21' ,'22' ,'23' ,'24' ,'25' ,'26' ,'27' ,'28' ,'29' ,'30'
      ,'31'
    ];
  }

  get periodInMonth ()
  {
    // return this.commonService.periodInMonth;
    return [
      'FIRST'
      , 'SECOND'
      , 'THIRD'
      , 'FOURTH'
      , 'LAST'
    ];
  }
}

export class CustomReport {
  ReportID: number = -1;
  ReportName: string;
  LoginID: string;
  Columns: string [];
  Filters: string [] = [];
  // These 2 are strings as the are in JSON and will need to be converted
  FiltersJSON: string;
  SchedulingJSON: string;
  ReportType: string = '';
}
